import type { JSONContent } from "@tiptap/core"
import { textToDoc } from "./serialize"
import { mentionDisplayLabel, mentionKey, type MentionCategory, type MentionItem } from "./types"

export function resolveCamLabel(items: MentionItem[], cameraId: number): string {
  const fromItems = items.find(
    (it) => mentionKey(it.category, it.id, it.stateId, it.attrKey) === mentionKey("cam", cameraId),
  )
  return fromItems?.label ?? `@cam[${cameraId}]`
}

/** Display labels for mention nodes in prompt text (for tests / inspection). */
export function mentionDisplayLabelsInPromptText(text: string, items: MentionItem[]): string[] {
  const doc = textToDoc(text, items)
  const labels: string[] = []

  const visitInline = (nodes: JSONContent[] | undefined) => {
    for (const node of nodes ?? []) {
      if (node.type !== "mention") continue
      const category = (node.attrs?.category ?? "reference") as MentionCategory
      labels.push(mentionDisplayLabel(category, String(node.attrs?.label ?? "")))
    }
  }

  for (const node of doc.content ?? []) {
    if (node.type === "paragraph") {
      visitInline(node.content)
    } else if (node.type === "promptBlock") {
      const cameraPresetIdRaw = node.attrs?.cameraPresetId
      const cameraId = cameraPresetIdRaw != null && cameraPresetIdRaw !== "" ? Number(cameraPresetIdRaw) : null
      if (cameraId != null && Number.isFinite(cameraId)) {
        labels.push(mentionDisplayLabel("cam", resolveCamLabel(items, cameraId)))
      }
      for (const child of node.content ?? []) {
        if (child.type === "paragraph") visitInline(child.content)
      }
    }
  }
  return labels
}
